// Vuex dashboard module main file

import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  elementsIds: [],
  liveList: [],
  wiretappingUuid: '',
};

const getters = {
  elementsIds: state => state.elementsIds,
  liveList: state => state.liveList,
  wiretappingUuid: state => state.wiretappingUuid,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
  modules: {},
};

export default Module;
